import React from "react";
import Image from "next/image";
import useTranslation from "next-translate/useTranslation";
import clsx from "clsx";

const FeatureSection = ({ feature, textLeft = false, imageWidth = 680, imageHeight = 646 }) => {
  const { t } = useTranslation("features");

  return (
    <div
      className={clsx(
        "flex flex-col items-start py-16 text-center lg:flex-row lg:items-center lg:gap-16 lg:py-32",
        textLeft && "lg:flex-row-reverse lg:justify-between"
      )}
    >
      <div className="m-auto w-full shrink-0 lg:w-1/2">
        <Image
          src={`/features/${feature}.png`}
          alt={t(`${feature}.title`)}
          width={imageWidth}
          height={imageHeight}
          className="object-contain"
          quality={100}
        />
      </div>
      <div className="w-full px-4 text-left lg:w-1/2 lg:px-0">
        <div className="font-title text-lg font-semibold lg:text-3xl">{t(`${feature}.title`)}</div>
        <div className="mt-2 text-grey-700 lg:mt-6 lg:text-xl">{t(`${feature}.description`)}</div>
      </div>
    </div>
  );
};

export default FeatureSection;
